import { createAsyncThunk } from '@reduxjs/toolkit';
import { projectSettingsApi } from 'container/projectSettingsApi';
import { pulseProjectApi } from 'container/pulseProjectApi';
import { SurveySettingsModel } from 'api/dto/SurveySettings.dto';
import { selectIsPulseTemplate } from 'reduxStore/project/projectSelector';
import { serializeError } from 'shared/utils/redux';

import { STORE_NAME } from '../initialState';

export const fetchProjectSettings = createAsyncThunk(
  `${STORE_NAME}/fetchProjectSettings`,
  ({ projectId }: { projectId: number }) => {
    return projectSettingsApi.fetch(projectId);
  },
  { serializeError },
);

export const updateProjectSettings = createAsyncThunk(
  `${STORE_NAME}/updateProjectSettings`,
  async (
    { projectId, settings }: { projectId: number; settings: SurveySettingsModel },
    { getState },
  ) => {
    const project = await projectSettingsApi.update(projectId, settings);

    const isPulseTemplate = selectIsPulseTemplate(getState());
    if (isPulseTemplate) {
      return pulseProjectApi.get(projectId);
    } else {
      return project;
    }
  },
  { serializeError },
);
